import { useDispatch, useSelector } from 'react-redux';
import { fetchUserById, handleFollowUnfollow } from '../redux/usersSlice';
import { UsersService } from '../services';

export const useUser = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.entities);

  const fetchUsersByIds = async (userIds) => {
    const usersToFetch = userIds.filter(id => !users[id]);
    if (usersToFetch?.length) {
      await Promise.all(usersToFetch.map(userId => dispatch(fetchUserById({ userId }))));
    }
  };
  const handleUserFollowUnfollow = async (userId, currentUserId, isFollowed) => {
    const response = await UsersService.followUnfollowUser(userId, isFollowed ? 'unfollow' : 'follow');
    if (response.data.success) {
      dispatch(handleFollowUnfollow({userId, currentUserId, actionType: isFollowed ? 'unfollow' : 'follow'}))
      return true;
    } else{
      console.error('Error following/unfollowing user:', response.error);
      return false;

    }
  }
  const fetchFollowersAndFollowingData = async(userId, page = 1, action) => {
    try {
      if (action === "follow") {
        const response = await UsersService.getUserFollowers(userId, {page});
        return response.data?.data;
      } else {
        const response = await UsersService.getUserFollowing(userId, {page});
        return response.data?.data;
      }
    } catch (error) {
      console.error('Error fetching followers:', error);
      return [];
    }
  }

  return {
    users, 
    fetchUsersByIds, 
    handleUserFollowUnfollow, 
    fetchFollowersAndFollowingData,
  };
};